import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Manager } from '../models/manager';
import { Pagination } from '../models/pagination';
import { FilterManagersForm } from '../pages/Administration/Managers/FilterManagers';

const baseUrl = '/manager';

const getManagerById = (id: number): Promise<AxiosResponse<Manager>> =>
  axios.get<Manager>(`${baseUrl}/${id}`);

const getManagers = (
  data?: FilterManagersForm,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Manager>>> =>
  axios.post<Pagination<Manager>>(`${baseUrl}/filter`, data, config);

const createManager = (payload: Manager): Promise<AxiosResponse<Manager>> =>
  axios.post<Manager>(`${baseUrl}`, payload);

const createManagerByAdmin = (
  payload: Manager
): Promise<AxiosResponse<Manager>> =>
  axios.post<Manager>(`${baseUrl}/create-by-admin`, payload);

const updateManager = (payload: Manager): Promise<AxiosResponse<void>> =>
  axios.put<void>(`${baseUrl}`, payload);

const updateManagerByAdmin = (payload: Manager): Promise<AxiosResponse<void>> =>
  axios.put<void>(`${baseUrl}/update-by-admin`, payload);

const getManagerList = (
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Manager[]>> =>
  axios.get<Manager[]>(`${baseUrl}`, config);

const exportManagers = (
  data?: FilterManagersForm
): Promise<AxiosResponse<string>> =>
  axios.post<string>(`${baseUrl}/export`, data, { responseType: 'blob' });

export const managerService = {
  getManagerById,
  getManagers,
  getManagerList,
  exportManagers,
  createManager,
  createManagerByAdmin,
  updateManager,
  updateManagerByAdmin
};
